import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listPosts } from "@/lib/api";
import { ArrowUpRight, Loader2 } from "lucide-react";

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    listPosts()
      .then((data) => setPosts(data))
      .catch(() => setError("Failed to load insights. Please try again."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <section className="pt-16 md:pt-24 pb-10" data-testid="blog-hero">
        <div className="container-app max-w-4xl">
          <div className="eyebrow">Insights</div>
          <h1 className="mt-3 text-5xl md:text-6xl leading-tight">
            Notes from the <span className="italic text-gold">field</span>.
          </h1>
          <p className="mt-5 text-lg text-navy/70 max-w-2xl leading-relaxed">
            Practical guidance on bookkeeping, business formation, credit, taxes,
            and the financial life of your enterprise.
          </p>
        </div>
      </section>

      <section className="pb-20" data-testid="blog-list">
        <div className="container-app">
          {loading && (
            <div className="flex items-center gap-2 text-navy/60">
              <Loader2 className="w-4 h-4 animate-spin" /> Loading…
            </div>
          )}
          {error && <p className="text-red-500">{error}</p>}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p) => (
              <Link
                key={p.id}
                to={`/insights/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="card overflow-hidden group block"
              >
                <img
                  src={p.cover_image}
                  alt={p.title}
                  className="w-full h-44 object-cover group-hover:scale-105 transition duration-700"
                />
                <div className="p-6">
                  <span className="text-[10px] uppercase tracking-widest text-gold">
                    {p.category}
                  </span>
                  <h3 className="mt-2 text-xl leading-snug">{p.title}</h3>
                  <p className="mt-2 text-sm text-navy/65 leading-relaxed line-clamp-3">
                    {p.excerpt}
                  </p>
                  <div className="mt-5 inline-flex items-center text-sm text-navy/80 group-hover:text-gold transition">
                    Read more <ArrowUpRight className="w-4 h-4 ml-1" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
